import {
  AgreementDetails,
  // VendorDocuments,
} from '.';
export const AgreementsAndComplianceVerticalTabsData = [
  {
    label: 'agreement-details',
    component: AgreementDetails,
  },

  // {
  //   label: 'documents',
  //   component: VendorDocuments,
  //   // permissionsList: Object.values(DevelopersPermissions),
  //   // permissionsId: DevelopersPermissions.Documents.permissionsId,
  // },
];
